import React from 'react'

export const TargetAddressContext = React.createContext({ targetAddress: "", updateTargetAddress: () => { } })
